export enum Key {
    access_token = 'access_token',
    refresh_token = 'refresh_token',
    token_expiry = 'refresh'
}

const getItem = <T>(key: string): T | null => {
    const value = window.localStorage.getItem(key);
    if (value) {
        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    }
    return null;
};

const removeItem = (key: string): void => {
    window.localStorage.removeItem(key);
};

const setItem = (key: string, value: any): void => {
    window.localStorage.setItem(key, JSON.stringify(value));
};

const LocalStorageService = {
    removeItem,
    getItem,
    setItem
};

export default LocalStorageService
